import { isMobile } from '@pascal/pascal-core';
import { containerNames } from '../../../enums/containerNames';
import { PixiBase } from '../../../core/pixi/PixiBase';
import { gameResourceNames } from '../../../core/pixi/resources';
import { Spine } from '../../../services/spine';
import {
  FISH_ANIMATION_NAMES,
  FishingOddConfigMobile,
  FishingOddConfigWeb,
} from '../../../core/constants/gameLayers';
import { TYPE_SHARK } from '../../../enums/uiConfig';
import { mobileGameConfigs, webGameConfigs } from '../../../core/pixi/config';
// import { baseHeight, baseWidth } from '../../core/pixi/config';

export class FishPopupDrawer {
  constructor() {
    this.animations = {};
    this.fishPopupContainer = PixiBase.createContainer(containerNames.fishPopupContainer);
  }

  setupFishPopup() {
    this.fishPopup = new Spine({ key: gameResourceNames.fishPopup });
    if (isMobile()) {
      const { width, height } = mobileGameConfigs;

      PixiBase.setPosition(this.fishPopup, { x: width / 2, y: height / 2 });
    } else {
      const { width, height } = webGameConfigs;

      PixiBase.setPosition(this.fishPopup, { x: width / 2, y: height / 2 });
    }

    // PixiBase.setPosition(this.fishPopup, { x: isMobile() ? width / 2 : 287, y: 140 });
    this.fishPopupContainer.addChild(this.fishPopup);
    this.createOddText();
  }

  setSkeletonToSpine(skeletonType) {
    this.fishPopup.skeleton.setSkinByName(`fish${skeletonType}`);
  }

  resetSkeletonFromFishSpine() {
    this.fishPopup.skeleton.setSkin(null);
    this.fishPopup.skeleton.setSlotsToSetupPose();
  }

  playFishAnimation(skinName) {
    this.setSkeletonToSpine(`${skinName}`);
    return this.fishPopup.play(
      +skinName === TYPE_SHARK ? FISH_ANIMATION_NAMES.Shark : FISH_ANIMATION_NAMES.Fish
    );
  }

  stopFishAnimation() {
    if (this.fishPopup) {
      this.fishPopup.stop({ animationName: FISH_ANIMATION_NAMES.Fish });
    }
  }

  createOddText() {
    this.oddText = new PixiBase.PIXI.Text(
      ``,
      isMobile() ? FishingOddConfigMobile : FishingOddConfigWeb
    );
    this.oddText.anchor.set(0.5);
    this.slot = this.fishPopup.skeleton.findSlot('Odd');
    this.slot.currentSprite.addChild(this.oddText);
  }

  updateOddText(odd) {
    this.oddText.text = odd || odd === 0 ? `x${odd}` : '';
  }

  resetOddText() {
    this.slot.currentSprite.children = [];
  }

  resetAnimations() {
    this.stopFishAnimation();
  }

  execute(config) {
    this.config = config;
    this.setupFishPopup();
  }
}
